/**
 * Resolve MongoDB user id from merged auth user (Firebase + /api/auth/me + Firestore).
 * GET /api/auth/me sets `uid` to the Mongo ObjectId string; Firebase's `uid` is a longer opaque id.
 */
const MONGO_OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

export function getMongoUserIdFromAuthUser(user) {
  if (!user) return null;
  if (user._id != null) return String(user._id);
  if (user.id != null) return String(user.id);
  if (user.userId != null) return String(user.userId);
  if (user.uid != null && MONGO_OBJECT_ID_RE.test(String(user.uid))) {
    return String(user.uid);
  }
  return null;
}
